"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButtonWithDigitalHig = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _constants = require("./constants");
var _excluded = ["children", "className", "variant", "fullWidth"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var iconButtonWithDigitalHig = exports.iconButtonWithDigitalHig = function iconButtonWithDigitalHig(BaseMuiIconButton) {
  var IconButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      fullWidth = _ref.fullWidth,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var muiIconButtonApiPresets = {
      // children
      // classes
      // color
      // disabled
      // disableRipple
      // disableFocusRipple
      // edge
      // size
      // sx
    };
    var classnames = className && className.split(" ") || [];
    fullWidth && classnames.push("DhigIconButton--fullWidth");
    classnames.push("DhigIconButton--variant--".concat(variant));
    return /*#__PURE__*/_react.default.createElement(BaseMuiIconButton, _extends({}, muiIconButtonApiPresets, otherProps, {
      className: classnames.join(" "),
      ref: ref
    }), children);
  });
  IconButton.propTypes = {
    children: _propTypes.default.node,
    className: _propTypes.default.string,
    fullWidth: _propTypes.default.bool,
    sizes: _propTypes.default.oneOf(_constants.availableSizes),
    variant: _propTypes.default.oneOf(_constants.availableVariants)
  };
  IconButton.defaultProps = {
    disabled: false,
    fullWidth: false,
    size: _constants.sizes.MEDIUM,
    variant: _constants.variants.CONTAINED
  };
  IconButton.displayName = "IconButton";
  return IconButton;
};
var IconButton = iconButtonWithDigitalHig(_IconButton.default);
var _default = exports.default = IconButton;